import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";
import confetti from "canvas-confetti";
import { Link } from "react-router-dom";
import { FLOOR_HEADS, FLOOR_MANAGERS } from "../json/salesTarget";



/* ================= CONFIG ================= */
// const FLOOR_HEADS = [
//   {
//     key: "GMIT",
//     name: "Rahul Bhusan",
//     target: "1200",
//     color: "#f97316",
//     photo: "/managers/rahulbhusan.jpeg",
//   },
//   {
//     key: "ALTF",
//     target: "2000",
//     name: "Anand Suman",
//     color: "#0f172a",
//     photo: "/managers/anandsuman.png",
//   },
// ];




// const FLOOR_MANAGERS = {
//   GMIT: ["JayVijay5099", "LavitBhati714","Nitin5210"],
//   ALTF: [
//     "SanjayRewani1619",
//     "ASHWANI3434",
//     // "Anand Suman 254",
//     "Himanshu1203",
//     "Abhishek4629",
//   ],
// };

const REFRESH_INTERVAL = 30000;

/* ================= MAIN ================= */
export default function FloorsDisplay() {


//       const navigate = useNavigate();

// /* ================= AUTO REDIRECT (5s) ================= */
// useEffect(() => {
//   const timer = setTimeout(() => {
//     navigate("/screen/floors-display"); // 🔁 change to your target page
//   }, 10000);

//   return () => clearTimeout(timer);
// }, [navigate]);


// const navigate = useNavigate();

// useEffect(() => {
//   const timer = setTimeout(() => {
//     navigate(
//       "/screen/manager-display?A=ASHWANI3434&B=Himanshu1203",
//       { replace: true }
//     );
//   }, 25000);

//   return () => clearTimeout(timer);
// }, [navigate]);





  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [apiError, setApiError] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      fetchSales(); // auto refresh when internet returns
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const [orders, setOrders] = useState({ GMIT: 0, ALTF: 0 });
  const [loading, setLoading] = useState(true);
  const [totalOrders, setTotalOrders] = useState(0);

  //   const fetchSales = async () => {
  //     try {
  //       const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
  //         headers: {
  //           token: "ad2355a9d54335e27e2c3a3ed5b6e381",
  //           "Content-Type": "application/json",
  //         },
  //         params: {
  //           from_date: "2026-01-27",
  //           to_date: "2026-01-27",
  //         },
  //       });

  //       const managers = res?.data?.data?.result?.data?.managers || [];
  //       const totalOrders = res?.data?.data?.result.data.total.totalOrders || "";
  //       setTotalOrders(totalOrders);

  //       const sumOrders = (names) =>
  //         managers
  //           .filter((m) => names.includes(m.o_manager_name))
  //           .reduce((acc, m) => acc + Number(m.totalOrders || 0), 0);

  //       setOrders({
  //         GMIT: sumOrders(FLOOR_MANAGERS.GMIT),
  //         ALTF: sumOrders(FLOOR_MANAGERS.ALTF),
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const fetchSales = async () => {
    if (!navigator.onLine) {
      setIsOnline(false);
      setApiError(true);
      return;
    }

    try {
      setApiError(false);

      const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
        headers: {
          token: "ad2355a9d54335e27e2c3a3ed5b6e381",
          "Content-Type": "application/json",
        },
        params: {
          from_date: "2026-01-27",
          to_date: "2026-01-27",
        },
        timeout: 8000, // ⏱ prevents hanging
      });

      const managers = res?.data?.data?.result?.data?.managers || [];
      const totalOrders =
        res?.data?.data?.result?.data?.total?.totalOrders || 0;

      setTotalOrders(totalOrders);

      const sumOrders = (names) =>
        managers
          .filter((m) => names.includes(m.o_manager_name))
          .reduce((acc, m) => acc + Number(m.totalOrders || 0), 0);

      setOrders({
        GMIT: sumOrders(FLOOR_MANAGERS.GMIT),
        ALTF: sumOrders(FLOOR_MANAGERS.ALTF),
      });

      setIsOnline(true);
    } catch (err) {
      console.warn("Network/API error:", err.message);
      setApiError(true);
      setIsOnline(false);
    } finally {
      setLoading(false);
    }
  };

  console.log("Orders count:", totalOrders);
  useEffect(() => {
    fetchSales();
    const t = setInterval(fetchSales, REFRESH_INTERVAL);
    return () => clearInterval(t);
  }, []);

  const total = orders.GMIT + orders.ALTF;

  // Determine winner
  //   const winner =
  //     orders.GMIT === orders.ALTF
  //       ? null
  //       : orders.GMIT > orders.ALTF
  //       ? "GMIT"
  //       : "ALTF";

  const calcAchievement = (value, target) =>
    Math.round((value / Number(target)) * 100);

  const gmitAch = calcAchievement(orders.GMIT, FLOOR_HEADS[0].target);
  const altfAch = calcAchievement(orders.ALTF, FLOOR_HEADS[1].target);

  //   const winner =
  //     gmitAch === altfAch ? null : gmitAch > altfAch ? "GMIT" : "ALTF";
  const winner =
    gmitAch === altfAch ? "DRAW" : gmitAch > altfAch ? "GMIT" : "ALTF";

  // Trigger confetti every update
  useEffect(() => {
    if (!loading) {
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 },
      });
    }
  }, [orders]); // Runs every time orders change

  useEffect(() => {
    if (!loading && (gmitAch >= 100 || altfAch >= 100)) {
      confetti({
        particleCount: 180,
        spread: 120,
        origin: { y: 0.6 },
      });
    }
  }, [gmitAch, altfAch]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-4xl font-bold">
        Loading…
      </div>
    );
  }

  return (
    // <div className="h-screen bg-gray-50 text-gray-900 px-10 py-2 flex flex-col">
    <div className="min-h-screen bg-gray-50 text-gray-900 px-4 sm:px-6 lg:px-10 py-2 flex flex-col ">
      {/* HEADER */}
      {/* <div className="flex justify-between items-center mb-12"> */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-6 mb-8 lg:mb-12">
        <div>
          {/* <h1 className="text-5xl font-extrabold tracking-tight"> */}
          <h1 className="hidden md:block text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
            Live Floor Performance
          </h1>
          <p className="text-gray-600 mt-2 text-lg hidden md:block">
            Real-time order dominance view
          </p>
        </div>
        <div className="text-center md:text-right flex flex-row md:flex-col gap-4 md:gap-2 justify-between items-center">
          {/* <div className="hidden md:block text-sm uppercase tracking-widest text-gray-500">
            Total Orders
          </div> */}
          {/* <div className="text-6xl font-extrabold">{total}</div> */}
          {/* <div className="text-6xl font-extrabold">{totalOrders}</div> */}
          <div className="border-green-500 text-4xl sm:text-5xl lg:text-6xl font-extrabold bg-green-500/10 inline-block px-4 py-2 rounded-lg">
            {totalOrders}
          </div>

          <Link
            to="/screen/manager-display?A=SanjayRewani1619&B=Abhishek4629"
            className="bg-black text-white px-6 py-3  rounded-xl text-lg hover:scale-105 transition md:hidden"
          >
            Managers Battle
          </Link>
        </div>
      </div>

      {/* MAIN CARDS */}
      <div className="grid grid-cols-2 md:grid-cols-[40%_20%_40%] items-center gap-1 w-full mx-auto">
        {/* <FloorCard
          floor={FLOOR_HEADS[0]}
          value={orders.GMIT}
          opponent={orders.ALTF}
          isWinner={winner === "GMIT"}
        /> */}
        <FloorCard
          floor={FLOOR_HEADS[0]}
          value={orders.GMIT}
          achievement={gmitAch}
          isWinner={winner === "GMIT"}
          isLoser={winner === "ALTF"}
          isDraw={winner === "DRAW"}
        />

        {/* VS */}
        <div className="text-center hidden md:block">
          <div className="text-[10rem] font-extrabold text-gray-300 leading-none">
            VS
          </div>
        </div>
        {/* 
        <FloorCard
          floor={FLOOR_HEADS[1]}
          value={orders.ALTF}
          opponent={orders.GMIT}
          isWinner={winner === "ALTF"}
        /> */}

        <FloorCard
          floor={FLOOR_HEADS[1]}
          value={orders.ALTF}
          achievement={altfAch}
          isWinner={winner === "ALTF"}
          isLoser={winner === "GMIT"}
          isDraw={winner === "DRAW"}
        />
      </div>
      {/* INTERNET DISCONNECTED POPUP */}

      {!isOnline && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="bg-white rounded-3xl shadow-2xl p-10 text-center w-[420px]"
          >
            <div className="text-6xl mb-4">📡</div>

            <h2 className="text-3xl font-bold text-gray-900">
              No Internet Connection
            </h2>

            <p className="text-gray-600 mt-3 text-lg">
              {apiError
                ? "Unable to reach server. Please check your internet."
                : "Waiting for network connection..."}
            </p>

            <p className="text-gray-600 mt-3 text-lg">
              Please check your network.
              <br />
              Live data will resume automatically once connected.
            </p>

            <button
              onClick={() => {
                if (navigator.onLine) {
                  fetchSales();
                } else {
                  setApiError(true);
                }
              }}
              className="mt-8 px-8 py-3 rounded-full text-lg font-semibold bg-orange-500 text-white hover:bg-orange-600 transition"
            >
              🔄 Retry Connection
            </button>
          </motion.div>
        </div>
      )}
    </div>
  );
}

// /* ================= FLOOR CARD ================= */
// function FloorCard({ floor, value, opponent, isWinner }) {
//   const lead = value - opponent;
//   const percentage =
//     opponent === 0 ? 100 : Math.round((value / (value + opponent)) * 100);

//   return (
//     <motion.div
//       animate={{
//         y: isWinner ? [-4, 0, -4] : 0, // small bounce for winner
//         scale: isWinner ? [1, 1.04, 1] : 1,
//         boxShadow: isWinner
//           ? [
//               "0 0 10px rgba(0,0,0,0)",
//               `0 0 30px ${floor.color}`,
//               "0 0 10px rgba(0,0,0,0)",
//             ]
//           : "0 0 10px rgba(0,0,0,0)",
//       }}
//       transition={{ duration: 1, repeat: isWinner ? Infinity : 0 }}
//       className={`relative rounded-3xl p-10 py-4 border overflow-hidden shadow-xl
//         ${isWinner ? `bg-white text-gray-900 border border-[${floor.color}] ${floor.color}` : "bg-gray-100 border-gray-300"}
//       `}
//     >
//       {/* WINNER STRIP */}
//       {isWinner && (
//         <div
//           className="absolute top-0 left-0 right-0 h-3 rounded-t-3xl"
//           style={{ backgroundColor: floor.color }}
//         />
//       )}

//       {/* HEADER */}
//       <div className="flex items-center flex-col gap-6">
//               {/* <div>
//           <h2 className="text-6xl font-bold">{floor.key}</h2>
//           <p className="text-lg opacity-80">{floor.name}</p>
//         </div> */}
//         <img
//           src={floor.photo}
//           className="w-96 h-96 min-h-96 min-w-96 rounded-full object-cover border-4"
//           style={{ borderColor: floor.color }}
//         />
//         <div className="text-center">
//           <h2 className="text-3xl font-bold">{floor.key}</h2>
//           <p className="text-lg opacity-80">{floor.name}</p>
//         </div>
//       </div>

//       {/* VALUE */}
//       <div className="mt-12">
//         <div className="text-5xl font-extrabold" style={{ color: floor.color }}>
//           {value}/
//           <p className="inline">{floor.target}</p>
//         </div>
//         <div className="text-lg uppercase tracking-widest opacity-70 mt-2">
//           Orders
//         </div>
//       </div>

//       {/* PROGRESS */}
//       <div className="mt-5">
//         <div className="h-4 bg-gray-300 rounded-full overflow-hidden">
//           <motion.div
//             initial={{ width: 0 }}
//             animate={{ width: `${percentage}%` }}
//             transition={{ duration: 0.8 }}
//             className="h-full rounded-full"
//             style={{ backgroundColor: floor.color }}
//           />
//         </div>
//         <div className="flex justify-between text-sm mt-1 opacity-70">
//           <span>{percentage}% share</span>
//           {lead !== 0 && (
//             <span
//               className={
//                 lead > 0
//                   ? "text-green-500 font-semibold"
//                   : "text-red-500 font-semibold"
//               }
//             >
//               {lead > 0 ? `+${lead}` : lead} lead
//             </span>
//           )}
//         </div>
//       </div>

//       {/* WINNER LABEL */}
//       {isWinner && (
//         <motion.div
//           initial={{ opacity: 0, y: -10 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="absolute top-4 right-4 text-sm font-bold tracking-widest px-4 py-2 rounded-full shadow-lg"
//           style={{
//             backgroundColor: floor.color,
//             color: "white",
//           }}
//         >
//           WINNING FLOOR
//         </motion.div>
//       )}
//     </motion.div>
//   );
// }

function FloorCard({ floor, value, achievement, isWinner, isLoser, isDraw }) {
  const target = Number(floor.target);
  const remaining = Math.max(target - value, 0);

  const getProgressColor = (percent) => {
    if (percent >= 100) return "#22c55e"; // green
    if (percent >= 90) return "#4ade80";
    if (percent >= 80) return "#84cc16";
    if (percent >= 70) return "#facc15";
    if (percent >= 60) return "#fbbf24";
    if (percent >= 50) return "#fb923c";
    if (percent >= 40) return "#f97316";
    if (percent >= 30) return "#ef4444";
    if (percent >= 20) return "#dc2626";
    return "#b91c1c"; // deep red
  };

  const progressColor = getProgressColor(achievement);

  // STATUS COLORS
  //   const status =
  //     achievement >= 100
  //       ? { label: "TARGET ACHIEVED", color: "bg-green-500", bar: "#22c55e" }
  //       : achievement >= 70
  //       ? { label: "ON TRACK", color: "bg-yellow-400", bar: "#facc15" }
  //       : { label: "BEHIND", color: "bg-red-500", bar: "#ef4444" };

  // STATUS COLORS (derived from progress %)
  const status =
    achievement >= 100
      ? {
          label: "TARGET ACHIEVED",
          color: "bg-green-600",
          bar: "#22c55e",
          border: "border-green-600",
        }
      : achievement >= 90
      ? {
          label: "EXCELLENT",
          color: "bg-green-400",
          bar: "#4ade80",
          border: "border-green-400",
        }
      : achievement >= 80
      ? {
          label: "VERY GOOD",
          color: "bg-lime-500",
          bar: "#84cc16",
          border: "border-lime-500",
        }
      : achievement >= 70
      ? {
          label: "ON TRACK",
          color: "bg-yellow-400",
          bar: "#facc15",
          border: "border-yellow-400",
        }
      : achievement >= 60
      ? {
          label: "NEEDS PUSH",
          color: "bg-amber-400",
          bar: "#fbbf24",
          border: "border-amber-400",
        }
      : achievement >= 50
      ? {
          label: "BELOW AVERAGE",
          color: "bg-orange-400",
          bar: "#fb923c",
          border: "border-orange-400",
        }
      : achievement >= 40
      ? {
          label: "WARNING",
          color: "bg-orange-500",
          bar: "#f97316",
          border: "border-orange-500",
        }
      : achievement >= 30
      ? {
          label: "CRITICAL",
          color: "bg-red-500",
          bar: "#ef4444",
          border: "border-red-500",
        }
      : achievement >= 20
      ? {
          label: "VERY CRITICAL",
          color: "bg-red-600",
          bar: "#dc2626",
          border: "border-red-600",
        }
      : {
          label: "ALERT",
          color: "bg-red-700",
          bar: "#b91c1c",
          border: "border-red-700",
        };

  return (
    <motion.div
      animate={{
        y: isWinner ? [-6, 0, -6] : 0,
        scale: isWinner ? [1, 1.05, 1] : 1,
        boxShadow: isWinner
          ? "0 0 40px rgba(34,197,94,0.6)"
          : "0 0 15px rgba(0,0,0,0.15)",
      }}
      transition={{ duration: 1, repeat: isWinner ? Infinity : 0 }}
      className={`relative rounded-3xl p-5 border bg-white shadow-2xl overflow-hidden ${status.border}`}
    >
      {/* STATUS STRIP */}
      {/* <div className={`absolute top-0 left-0 right-0 h-3 ${status.color}`} /> */}
      <div className={`absolute top-0 left-0 right-0 h-3 ${status.color}`} />

      {/* IMAGE */}
      <div className="flex flex-col items-center gap-4">
        <img
          src={floor.photo}
          className="w-40 h-40 md:w-96 md:h-96 rounded-full object-cover border-circle border-4"
          //   style={{ borderColor: status.bar }}
          style={{ borderColor: progressColor }}
        />

        <div className="text-center">
          <h2 className="text-lg md:text-4xl font-bold">{floor.key}</h2>
          <p className="text-md md:text-xl opacity-80">{floor.name}</p>
        </div>
      </div>

      {/* NUMBERS */}
      <div className="mt-8 text-center">
        <div className="text-xl md:text-6xl font-extrabold">
          {value} / <span className="opacity-60">{target}</span>
        </div>
        <p className="mt-2 text-lg opacity-70">
          {remaining > 0
            ? `${remaining} orders to target`
            : "Target completed 🎉"}
        </p>
      </div>

      {/* PROGRESS BAR */}
      <div className="mt-6">
        <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${Math.min(achievement, 100)}%` }}
            transition={{ duration: 0.6 }}
            className="h-full rounded-full"
            style={{ backgroundColor: progressColor }}
          />
        </div>

        <div className="flex justify-between mt-2 text-sm text-gray-600">
          <span>{achievement}% achieved</span>
          <span>
            {achievement >= 100
              ? "Excellent"
              : achievement >= 70
              ? "On Track"
              : "Needs Push"}
          </span>
        </div>
      </div>

      {/* WINNER BADGE */}
      {isWinner && (
        <div className="absolute top-4 right-4 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-semibold shadow">
          🏆 Winner
        </div>
      )}
      {isLoser && (
        <div className="absolute top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold shadow">
          😞 Loser
        </div>
      )}
      {isDraw && (
        <div className="absolute top-4 right-4 bg-gray-700 text-white px-4 py-2 rounded-full text-sm font-semibold shadow">
          🤝 Draw
        </div>
      )}
    </motion.div>
  );
}
